module.exports = __webpack_public_path__ + "static/media/logo_footer.4c9a144c.svg";